import { Controller } from "@hotwired/stimulus"

const HIDE_DELAY = 200

export default class extends Controller {
  static targets = ["image", "spinner"]

  connect() {
    this.dismissed = false
    if (!this.hasImageTarget) return

    this.handleLoad = this.handleLoad.bind(this)
    this.handleError = this.handleError.bind(this)
    this.imageTarget.addEventListener("load", this.handleLoad)
    this.imageTarget.addEventListener("error", this.handleError)

    if (this.imageTarget.complete) {
      requestAnimationFrame(() => {
        if (this.imageTarget.naturalWidth > 0) {
          this.showImage()
        } else {
          this.showFallback()
        }
      })
    }
  }

  disconnect() {
    if (!this.hasImageTarget) return
    this.imageTarget.removeEventListener("load", this.handleLoad)
    this.imageTarget.removeEventListener("error", this.handleError)
  }

  handleLoad() {
    this.showImage()
  }

  handleError() {
    this.showFallback()
  }

  showImage() {
    if (this.dismissed) return
    this.dismissed = true
    this.hideSpinner()
    if (this.hasImageTarget) {
      this.imageTarget.classList.remove("opacity-0")
      this.imageTarget.classList.remove("opacity-50")
    }
  }

  showFallback() {
    if (this.dismissed) return
    this.dismissed = true
    this.hideSpinner()
    if (this.hasImageTarget) {
      this.imageTarget.classList.remove("opacity-0")
      this.imageTarget.classList.add("opacity-50")
    }
  }

  hideSpinner() {
    if (!this.hasSpinnerTarget) return

    this.spinnerTarget.classList.add("opacity-0", "pointer-events-none")
    window.setTimeout(() => {
      this.spinnerTarget.classList.add("hidden")
    }, HIDE_DELAY)
  }
}
